<template>
  <div :class="$style['pt-branch-company-form']" v-loading="detail_loading">
    <pt-branch-company-with-data :isEdit="isEdit" :userLogin="userLogin" ref="form" @submitLoading="submitLoading"
      @detailLoading="detailLoading"></pt-branch-company-with-data>
    <div>
      <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
import PtBranchCompanyWithData from './withData'
// 组件class前缀
export default {
  name: 'pt-branch-company-form',
  components: {
    PtBranchCompanyWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail_loading: false
    }
  },
  methods: {
    detailLoading (val) {
      this.detailLoading = val
    },
    submitLoading (val) {
      this.loading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */

</style>
